<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="streetAreaName">Street Area Name</label>
                    <input type="text" class="form-control" id="streetAreaName" [(ngModel)]="target.streetAreaName" name="streetAreaName" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="subContractorVendorId">Sub Contractor</label>
                    <wj-combo-box
                        id="subContractorVendorId"
                        [(ngModel)]="target.subContractorVendorId"
                        name="subContractorVendorId"
                        [itemsSource]="subContractorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="supplier">Supplier</label>
                    <wj-combo-box
                        id="supplier"
                        [(ngModel)]="target.supplier"
                        name="supplier"
                        [itemsSource]="supplierOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="testingAgencyVendorId">Testing Agency</label>
                    <wj-combo-box
                        id="testingAgencyVendorId"
                        [(ngModel)]="target.testingAgencyVendorId"
                        name="testingAgencyVendorId"
                        [itemsSource]="testingAgencyOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="requiredMix">Required Mix</label>
                    <input type="text" class="form-control" id="requiredMix" [(ngModel)]="target.requiredMix" name="requiredMix" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="requiredCompaction">Required Compaction</label>
                    <input
                        type="text"
                        class="form-control"
                        id="requiredCompaction"
                        [(ngModel)]="target.requiredCompaction"
                        name="requiredCompaction"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="requiredThickness">Required Thickness</label>
                    <input
                        type="text"
                        class="form-control"
                        id="requiredThickness"
                        [(ngModel)]="target.requiredThickness"
                        name="requiredThickness"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minimumPavingTemp">Minimum Paving Temp</label>
                    <input
                        type="text"
                        class="form-control"
                        id="minimumPavingTemp"
                        [(ngModel)]="target.minimumPavingTemp"
                        name="minimumPavingTemp"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minimumNumberTest">Minimum # Test</label>
                    <input
                        type="text"
                        class="form-control"
                        id="minimumNumberTest"
                        [(ngModel)]="target.minimumNumberTest"
                        name="minimumNumberTest"
                    />
                </div>
            </div>
        </div>
        <h5 class="mt-2 mb-3">Road Base</h5>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="roadBaseDepth">Depth</label>
                    <input type="text" class="form-control" id="roadBaseDepth" [(ngModel)]="target.roadBaseDepth" name="roadBaseDepth" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="roadBaseCompactionRequired">Compaction Required</label>
                    <input
                        type="text"
                        class="form-control"
                        id="roadBaseCompactionRequired"
                        [(ngModel)]="target.roadBaseCompactionRequired"
                        name="roadBaseCompactionRequired"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="roadBaseTestingFrequency">Testing Frequency</label>
                    <input
                        type="text"
                        class="form-control"
                        id="roadBaseTestingFrequency"
                        [(ngModel)]="target.roadBaseTestingFrequency"
                        name="roadBaseTestingFrequency"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
